import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { DescriptionOutlined as InvoiceIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

interface SaleInvoiceToggleSectionProps {
  hasInvoice: boolean;
  onChange: (hasInvoice: boolean) => void;
}

const SaleInvoiceToggleSection: React.FC<SaleInvoiceToggleSectionProps> = ({
  hasInvoice,
  onChange,
}) => {
  return (
    <Box sx={{ mt: 2.5 }}>
      <Typography
        variant="h6"
        sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1, color: 'text.primary' }}
      >
        <InvoiceIcon color="primary" />
        Facturación
      </Typography>
      <Box
        sx={(theme) => ({
          p: 1.5,
          borderRadius: 2.5,
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor:
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.common.white, 0.04)
              : alpha(theme.palette.common.black, 0.02),
        })}
      >
        <ToggleButtonGroup
          exclusive
          size="small"
          value={hasInvoice ? 'with' : 'without'}
          onChange={(_event, value: 'with' | 'without' | null) => {
            if (value == null) return;
            onChange(value === 'with');
          }}
          aria-label="Facturación de la venta"
          fullWidth
        >
          <ToggleButton value="without" aria-label="Sin factura">
            Sin factura
          </ToggleButton>
          <ToggleButton value="with" aria-label="Con factura">
            Con factura
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default SaleInvoiceToggleSection;
